






















import { EnterpriseForm } from '../../../store/models/EnterpriseForm/EnterpriseForm';
import { Vue, Component, Prop, Watch} from 'vue-property-decorator';
import * as enterpriseFromService from '@/store/Services/enterpriseFormService.ts';
import  store from '@/store';
import * as $ from 'jquery';
import { EnterpriseFormTableBookmarkColumn } from '@/store/models/EnterpriseForm/EnterpriseFormTableBookmarkColumn';


@Component({
})
export default class EnterpriseFormLists extends Vue {
    
    enterpriseForms = [] as EnterpriseForm[];
    formSearchTxt = '';
    isLoading = false;
    shallLoadOnce=true;
    ownerId = '';
    created(){
        store.state.eventHub.$on('shallLoadEnterpriseFormListsEvent',this.loadEnterpriseForms);
    }

    mounted(){
        this.ownerId =  store.state.ownerId;
        if(this.ownerId === '')return;
        // store.state.eventHub.$on('shallLoadEnterpriseFormListsEvent',this.loadEnterpriseForms);
    }
  
     get filteredForms(){
        return this.enterpriseForms.filter(x=>x.name.includes(this.formSearchTxt));
    }

    getFromColor(color: number){
        if(color === 0) return 'var(--BackgroundTable1)';
        const result =  '#' + color.toString(16).substring(2);
        return result;
    }
    
    async showForm(id: string){
        this.ownerId = store.state.ownerId;
        const selectedForm =  this.enterpriseForms.find(x=>x.id === id);
        if(!selectedForm) return;
        if(!selectedForm.bookmarks)return;
        for(let i=0;i< selectedForm.bookmarks.length;i++) {
            if(selectedForm.bookmarks[i].tableColumns!= null && selectedForm.bookmarks[i].tableColumns!= undefined){
                if(selectedForm.bookmarks[i].tableColumns.length > 0)
                {
                    for(let j = 0;j<selectedForm.bookmarks[i].tableColumns.length;j++)
                    {
                        await this.updatePrams(selectedForm.bookmarks[i].tableColumns[j]);
                    }
                }
            }
        }
        this.$emit('enterprise-form-selected-Mobile',selectedForm);
    }

    async updatePrams(col: EnterpriseFormTableBookmarkColumn){
        if(!col)return;
        if(col.defaultValue){
                            if(col.defaultValue.includes("%%")){
                                 const updatedValue = await enterpriseFromService.updateParameter(this.ownerId,col.defaultValue);
                                 col.defaultValue = updatedValue;
                            }
                        }
    }
    async loadEnterpriseForms(ownerId: string){  
        console.log(ownerId) 
        try {
            this.isLoading = true;
            this.enterpriseForms =  await enterpriseFromService.getOwnerEnterpriseForms(ownerId);
            this.enterpriseForms = this.enterpriseForms.sort((x,y)=> y.selectionColor - x.selectionColor);
        } catch (error) {
            console.log(error);            
        }finally{
            this.isLoading = false;
        }

        // if(this.shallLoadOnce== true){
        //     try {
        //         this.isLoading = true;
        //         this.enterpriseForms =  await enterpriseFromService.getOwnerEnterpriseForms(this.ownerId);
        //         this.enterpriseForms = this.enterpriseForms.sort((x,y)=> y.selectionColor - x.selectionColor);
        //     } catch (error) {
        //         console.log()
        //     }finally{
        //         this.isLoading = false;
        //         this.shallLoadOnce= false;
        //     }
        // }
        
    }

    
}
